/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.2.6
* 
*******************************************************************************/
import klass from"../base/klass";export default klass.createAbstract({},{_storageManager:null,_system:null,_extensionManager:null,__id:"",init(t){t&&(this.__id=t.toLowerCase())},setup:klass.abstractFn,getExtensionManager(){return this._extensionManager},getId(){return this.__id},getStorageManager(){return this._storageManager},getSystem(){return this._system},deinit(){this.__id="",this._storageManager=null,this._system=null,this._extensionManager=null}});